module.exports = __webpack_public_path__ + "img/pijl-rechts-wit.a338f86770fa74485caf9f61bd09e551.svg";